import React, { useEffect, useState } from "react";
import styled from "styled-components";
import NavFront from "./Front/NavFront";
// import wing1 from "../../assets/wings1.svg";
import wing1 from "../../assets/wing.png";
import wing2 from "../../assets/wings2.svg";
import FooterNew from "../layouts/FooterNew";
import { Link, useHistory } from "react-router-dom";
import { useContext } from "react";
import { userContext } from "../../App";
import { auth, db } from "../../firebase";
import firebase from "../../firebase";
import '../../file.css';
import Search from "./Front/Search";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';
import Backdrop from '@material-ui/core/Backdrop';
import { lightBlue } from "@material-ui/core/colors";
import second_wing from "../../assets/32580_copy-removebg 1.svg";
import Footer from "../layouts/Footer";

const useStyles = makeStyles((theme) => ({

  root: {
    display: 'flex',
    fontFamily: "Rubik",
    justifyContent: "center",
  },
  content: {
    marginTop: "160px",
    fontFamily: 'Rubik',
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: "24px 24px",
    alignItems: "center",
    '@media (max-width: 617px)': {
      padding: "24px 15px 24px 15px",
    },
    '@media (max-width: 440px)': {
      marginTop: "90px",
      padding: "24px 8px 24px 8px",
    },
  },

  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: "20px",
  },
  knowledge: {
    color: "#5DB0D8",
    cursor: 'default',
    margin: "0 -5px",
    alignSelf: "flex-end",
    '@media (max-width: 690px)': {
      fontSize: "32px",
    },
    '@media (max-width: 617px)': {
      // margin: "0 -7px",
      fontSize: "28px",
    },
    '@media (max-width: 520px)': {
      fontSize: "23px",
      // margin: "0 -6px",
    },
  },
  fly: {
    '@media (max-width: 440px)': {
      position: "relative",
      bottom: "40px",
    },
  },
  p1: {
    fontSize: "18px",
    width: "640px",
    textAlign: "center",
    '@media (max-width: 690px)': {
      fontSize: "16px",
      width: "570px",
    },
    '@media (max-width: 617px)': {
      width: "500px",
    },
    '@media (max-width: 520px)': {
      fontSize: "14px",
      width: "auto",
    },
  },
  p2: {
    fontSize: '12px',
    margin: '0',
    padding: '10px 0',
    color: 'black',
    cursor: 'default',
    '@media (max-width: 690px)': {
      fontSize: "11px",
    },
    '@media (max-width: 520px)': {
      textAlign: "center",
      padding: '10px 5px',
    },
  },
  p3: {
    fontSize: '12px',
    margin: '0',
    padding: '10px 0',
    color: 'black',
    cursor: 'default',
    '@media (max-width: 690px)': {
      fontSize: "11px",
    },
  },
  p4: {
    fontSize: "11px",
    margin: '0',
    padding: '10px 0',
    textAlign: "center",
    color: "#A6A6A6",
    cursor: 'default',
    marginTop: '20px',
    '@media (max-width: 690px)': {
      fontSize: "10px",
    },
  },
  uploadbox: {
    width: "562px",
    // height: "fit-content",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "20px",
    justifyContent: "center",
    background: "#FFFFFF",
    border: "1px solid #000000",
    boxSizing: "border-box",
    '@media (max-width: 690px)': {
      width: "500px",
    },
    '@media (max-width: 617px)': {
      width: "450px",
    },
    '@media (max-width: 520px)': {
      width: "345px",
    },
    '@media (max-width: 380px)': {
      width: "290px",
    },
  },
  buttonlabel: {
    color: "white",
    background: "#5DB0D8",
    cursor: "pointer",
    borderRadius: "18px",
    width: "180px",
    padding: "8px",
    textAlign: "center",
    margin: "10px 0",
    '@media (max-width: 690px)': {
      width: "170px",
      padding: "6px",
      fontSize: "15px",
    },
    '@media (max-width: 440px)': {
      width: "140px",
      padding: "4px",
      fontSize: "13px",
    },
  }
}));
const File = () => {
  if (localStorage.getItem('allowed') === '0') {
    window.location.href = '/home';
  }
  const ColorButton = withStyles((theme) => ({
    root: {
      color: lightBlue[50],
      backgroundColor: lightBlue[500],
      '&:hover': {
        backgroundColor: lightBlue[700],

      },
    },
  }))(Button);
  const [completed, setCompleted] = useState(0);
  const [navClick, setnavClick] = useState(false);
  const [searchtype, setsearchtype] = useState([]);
  const [searchtext, setsearchtext] = useState('');
  const [allposts, setallposts] = useState([]);
  const [exacttitle, setexacttitle] = useState('');
  const [searchtitle, setsearchtitle] = useState([]);
  const [searchClicked, setsearchClicked] = useState(false);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const history = useHistory();
  const { state, dispatch } = useContext(userContext);
  useEffect(() => { }, [completed]);
  const containerStyles = {
    position: "relative",
    height: "20px",
    width: "100%",
    backgroundColor: "#e0e0de",
    borderRadius: 50,
  };

  const fillerStyles = {
    height: "100%",
    width: 0,
    backgroundColor: "#5DB0D8",
    borderRadius: "inherit",
    textAlign: "right",
  };

  const labelStyles = {
    padding: 5,
    color: "white",
    fontWeight: "bold",
  };

  console.log(state);
  const uploadPDF = (e) => {
    var fileSize = e.target.files[0].size / 1024 / 1024;
    if (fileSize <= 10) {
      console.log("Size within limits");
      console.log(e.target.files[0].size / 1024 / 1024)
      console.log(e.target.files[0]);
      const uid = auth.currentUser.uid;
      var da = new Date().getTime();
      const fileRef = firebase
        .storage()
        .ref()
        .child(`/folios/${uid}/${da}`);
      const uploadTask = fileRef.put(e.target.files[0]);
      uploadTask.on(
        "state_changed",
        (snapShot) => {
          let percentage = (snapShot.bytesTransferred / snapShot.totalBytes) * 100
          let element = document.getElementById('progress');
          element.style.width = percentage + '%';
          if (percentage >= 100)
            history.push("/upload");
          // setCompleted(
          //     (snapShot.bytesTransferred / snapShot.totalBytes) * 100
          //   )
        },
        (error) => {
          console.log(error);
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            const postArray = [];
            postArray.push({
              url: downloadURL,
            });
            console.log(downloadURL);
            localStorage.setItem(
              "post",
              JSON.stringify({
                tempURL: downloadURL,
              })
            );
            dispatch({ type: "POST_URL", payload: downloadURL });
          });
        }
      );

      console.log("UPLOAD DONE");
      // 
    }
    else {
      handleOpen();
      console.log("Size exceed limits");
      console.log(e.target.files[0].size / 1024 / 1024)
    }

  };

  return (
    <>
      <div>
        {/* Navbar */}
        <NavFront
          setnavClick={setnavClick}
          setsearchClicked={setsearchClicked}
          setexacttitle={setexacttitle}
          searchtitle={searchtitle}
          setsearchtitle={setsearchtitle}
          searchtext={searchtext}
          setsearchtext={setsearchtext}
          setsearchtype={setsearchtype}
        />
        {!searchClicked && searchtext !== "" ? (
          <Search
            exacttitle={exacttitle}
            searchtitle={searchtitle}
            setsearchClicked={setsearchClicked}
            searchtype={searchtype}
            searchtext={searchtext}
          />
        ) : null}
      </div>

      <div className={classes.root}
        style={{ minHeight: "100vh" }}
      >
        <main className={classes.content}>
          <Head style={{ cursor: 'default' }}>
            Let The{" "}
            <Span style={{ cursor: 'default' }}>
              <Image1 style={{ cursor: 'default' }} />
              <p className={classes.knowledge}>
                Knowledge
              </p>
              <Image2 style={{ cursor: 'default' }} />
              {/* <ImageT /> */}
            </Span>
            <text className={classes.fly}>Fly</text>
          </Head>
          <p className={classes.p1} style={{ cursor: 'default' }}>Upload notes, research findings, documents or any other written information that you think is worth sharing to the world</p>


          <div className={classes.uploadbox}>
            <p className={classes.p2} style={{ cursor: 'default' }}>
              Please don't upload scanned images, we'll remove them as they are not fun to read.
            </p>
            <input
              type="file"
              // accept="application/pdf"
              accept=".pdf"
              onChange={(e) => uploadPDF(e)}
              id="upload"
              hidden
            />

            <label className={classes.buttonlabel} for="upload">
              Select File
            </label>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className={classes.modal}
              open={open}
              onClose={handleClose}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open}>
                <div className={classes.paper}>
                  <h5 id="spring-modal-title" style={{ marginBottom: "15px" }}>Sorry! Uploading failed!<br />Size of the PDF must not exceed the limit.</h5>
                  <div className={classes.root}>
                    <ColorButton variant="contained" onClick={() => { handleClose() }}>
                      OK
                    </ColorButton>

                  </div>
                </div>
              </Fade>
            </Modal>
            <p className={classes.p3} style={{ cursor: 'default' }}
            >
              Only <strong>Pdfs</strong> are supported | Max File Size 10MB
            </p>

            <p className={classes.p4} style={{ cursor: 'default' }}>
              By uploading, you agree to Friend a Book’s{" "}
              <Link to="/terms" style={{ textDecoration: 'none', cursor: 'pointer' }}>Terms Of Service</Link> and{" "}
              <Link to="/privacy" style={{ textDecoration: 'none', cursor: 'pointer' }}>Privacy Policy</Link>
            </p>
          </div>

          <Prog>
            <div style={containerStyles}>
              <div style={fillerStyles} id="progress">
                <span style={labelStyles}></span>
              </div>
            </div>
          </Prog>
        </main>
      </div >

      <hr style={{ margin: 0, height: "0.8px" }} />
      <Footer />

      {/* <Main>
        <Head style={{ cursor: 'default' }}>
          Let The{" "}
          <Span style={{ cursor: 'default' }}>
            <Image style={{ cursor: 'default' }} />
            <p
              style={{
                position: "relative",
                top: "8.37vh",
                color: "#5DB0D8",
                cursor: 'default'
              }}
            >
              Knowledge
            </p>
            <ImageT />
          </Span>
          Fly
        </Head>
        <p
          style={{
            fontFamily: "Rubik",
            marginTop: "0px",
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "18px",
            lineHeight: "21px",
            textAlign: "center",
            cursor: 'default'
          }}
        >
          Upload notes, research findings, documents or any other written information</p>
        <p
          style={{
            fontFamily: "Rubik",
            marginTop: "-15px",
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "18px",
            lineHeight: "21px",
            textAlign: "center",
            cursor: 'default'
          }}>that you think is worth sharing to the world{" "}
        </p>

        <form>
          <div
            style={{
              width: "562px",
              height: "196px",
              left: "439px",
              top: "400px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "20px",
              justifyContent: "center",
              background: "#FFFFFF",
              border: "1px solid #000000",
              boxSizing: "border-box",
            }}
          >
            <div className='dont'><p style={{ fontSize: '12px', color: 'black', cursor: 'default' }}>Please don't upload scanned images, we'll remove them as they are not fun to read.</p></div>
            <input
              type="file"
              accept="application/pdf"
              onChange={(e) => uploadPDF(e)}
              id="upload"
              hidden
            />

            <label className='buttonlabel'
              style={{
                fontFamily: "Rubik",
              }}
              for="upload"
            >
              Select File
            </label>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className={classes.modal}
              open={open}
              onClose={handleClose}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open}>
                <div className={classes.paper}>
                  <h5 id="spring-modal-title">Sorry File upload failed!!The size of the pdf exceeds the ( 10Mb ) limit.</h5>
                  <div className={classes.root}>
                    <ColorButton variant="contained" style={{ marginLeft: "50%" }} onClick={() => { handleClose() }}>
                      OK
                    </ColorButton>

                  </div>
                </div>
              </Fade>
            </Modal>
            <p className='allowed' style={{ cursor: 'default' }}
            >
              Only <span>Pdfs</span> are supported | Max File Size 10MB
            </p>

            <p
              style={{
                position: "relative",
                top: "4vh",
                fontSize: "11px",
                lineHeight: "12px",
                textAlign: "center",
                color: "#A6A6A6",
                cursor: 'default'
              }}
            >
              By uploading, you agree to Friend a Book’s{" "}
              <Link to="/terms" style={{ textDecoration: 'none', cursor: 'pointer' }}>Terms Of Service</Link> and{" "}
              <Link to="/privacy" style={{ textDecoration: 'none', cursor: 'pointer' }}>Privacy Policy</Link>
            </p>
          </div>
        </form>
        <Prog>
          <div style={containerStyles}>
            <div style={fillerStyles} id="progress">
              <span style={labelStyles}></span>
            </div>
          </div>
        </Prog>
      </Main> */}
      {/* <FooterNew /> */}
    </>
  );
};

const Prog = styled.div`
  width: 743px;
  margin: 30px 0;
  padding: 8px;
  background: #ffffff;
  border: 1px solid #000000;
  box-sizing: border-box;
  border-radius: 100px;
  @media (max-width: 790px){
    width: 640px;
  };
  @media (max-width: 690px){
    width: 570px;
  };
  @media (max-width: 617px){
    width: 500px;
    padding: 7px;
  };
  @media (max-width: 520px){
    width: 400px;
    padding: 7px;
  };
  @media (max-width: 440px){
    width: 345px;
    padding: 7px;
  };
  @media (max-width: 380px){
    width: 325px;
    padding: 7px;
  };
`;
const Span = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  bottom: 26px;
  align-items:center;
  transform: rotate(8deg) translateX(-12px) translateY(3px);
  @media (max-width: 440px){
    transform: none;
    bottom: 45px;
  };
`;

const Head = styled.p`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  font-size: 40px;
  text-align: center;
  @media (max-width: 690px){
  font-size: 35px;
  };
  @media (max-width: 617px){
  font-size: 30px;
  };
  @media (max-width: 520px){
  font-size: 25px;
  };
  @media (max-width: 440px){
    flex-direction: column;
  margin-bottom: 0px;
  };
`;
const Image1 = styled.img.attrs((props) => ({
  src: wing1,
}))`
transform: scaleX(-1);
width: 107px;
@media (max-width: 617px){
  width: 90px;
};
@media (max-width: 440px){
  width: 80px;
};
`;
const Image2 = styled.img.attrs((props) => ({
  src: wing1,
}))`

width: 107px;
@media (max-width: 617px){
  width: 90px;
};
@media (max-width: 440px){
  width: 80px;
};
`;
const ImageT = styled.img.attrs((props) => ({
  src: second_wing,
}))``;
export default File;
